// extracted by mini-css-extract-plugin
module.exports = {"info":"SuppliersList_info__3idQF","container":"SuppliersList_container__1shnW","text":"SuppliersList_text__26Af_"};